export const FormatirajTelefonskoStevilko = {
  methods: {
    onSelectInput (value) {
      this.iskalniNiz = ''
    },
    onDropdownVisibleChange (visible) {
      if (!visible) {
        this.iskalniNiz = ''
      }
    },
    onQueryChange (query) {
      this.iskalniNiz = query

      this.$nextTick(() => {
        const selectRef = this.$refs.telefonSelect
        if (!selectRef || !selectRef.$el) {
          return
        }
        const input = selectRef.$el.querySelector('input.el-input__inner')
        if (!input) {
          return
        }
        const trenutnoPrikazanQuery = input.value.replace(/\s+/g, '').toLowerCase()
        const prvotniQuery = this.iskalniNiz.replace(/\s+/g, '').toLowerCase()
        if (trenutnoPrikazanQuery !== prvotniQuery) {
          input.value = this.iskalniNiz
        }
      })
    },
    VrniFormatiranoTelefonsko (prenosniParameter, tipStevilke, dodajKlicno = false, dodajPlus = true) {
      if (prenosniParameter === undefined || prenosniParameter === '') {
        return ''
      }
      let stringNumber = String(prenosniParameter)
      if (dodajKlicno) {
        stringNumber = '386' + stringNumber.substring(1)
      }
      const prefix = dodajPlus ? '+' : ''
      if (tipStevilke === '080' || stringNumber.length === 9) {
        return prefix + stringNumber.replace(/(\d{3})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4')
      }
      if (tipStevilke === '5') {
        return prefix + stringNumber.replace(/(\d{3})(\d{2})(\d{3})(\d{3})/, '$1 $2 $3 $4')
      }
      return prefix + stringNumber.replace(/(\d{3})(\d)(\d{3})(\d{4})/, '$1 $2 $3 $4')
    },
    VrniFormatUmtsStevilke (param) {
      let pregledanaStevilka = ('' + param).replace(/\D/g, '')
      let ujemanje = pregledanaStevilka.match(/^(\d{3})(\d{3})(\d{3})$/)
      if (ujemanje) {
        let novFormatUjemanja1 = ujemanje[1].substring(1)
        return '+386 ' + novFormatUjemanja1 + ' ' + ujemanje[2] + ' ' + ujemanje[3]
      }
      return ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/GlobalnoTelefonija/FormatTelefonskeStevilke.js